export const STORE_ADD_ITEMS = 'STORE_ADD_ITEMS';
export const STORE_ADD_ORDER = 'STORE_ADD_ORDER';
export const STORE_REMOVE_ITEM = 'STORE_REMOVE_ITEM';
export const STORE_RESET_ORDERS = 'STORE_RESET_ORDERS';
export const STORE_UPDATE_ITEM = 'STORE_UPDATE_ITEM';



// WEBPACK FOOTER //
// ./src/constants/store.js